<template>
  <v-row class="px-0 mt-10 pa-0">
    <v-col cols="12" class="ma-0" style="padding-bottom: 0px; !important">
      <v-card  class="rounded-lg pa-5" rounded="lg" outlined>
        <v-row>
          <v-col cols="12" md="2" sm="12" class="d-flex justify-sm-center w-100" >
            <v-card-text style="width:190px" >
              <v-badge
                color="primary"
                content="Mentor"
                offset-x="30"
                offset-y="80"
                size="5"
              >
                <v-avatar size="90" color="teal" v-if="!this.user.profile.avatar">
                  <span class="white--text text-h5">
                    {{ this.user.profile.first_name.charAt(0).toUpperCase() }}
                  </span>
                </v-avatar>
                <v-avatar size="90" v-else>
                  <v-img :src="this.user.profile.avatar"></v-img>
                </v-avatar>
              </v-badge>
            </v-card-text>
          </v-col>
          <v-col cols="12" md="6" sm="12" class="d-flex justify-md-start justify-sm-center w-100">
            <v-card-text style="width:auto" >
                <h2 class="user-name">{{this.user.profile.first_name + " " + this.user.profile.last_name}}</h2>
                <div class="user-meta">
                  <span class="user-facts-bold">{{approved.length}} </span> <span class="user-facts mr-1">blogs  </span>
                  <span class="user-facts-bold">{{drafts.length}} </span> <span class="user-facts mr-1"> drafts   </span>
                  <span class="user-facts-bold">{{rejected.length}} </span> <span class="user-facts mr-1">rejected  </span>
                </div>
            </v-card-text>
          </v-col>
          <v-col cols="12" md="4" sm="12" class="d-flex justify-center align-center">
            <v-card-text class="d-sm-flex justify-center w-100">
              <span class="subscription" >Your subscription ends in 10 days </span>
              <span class="mx-2 renew"> | </span>
              <span class="mx-2 renew"> Renew</span>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col cols="12" >
      <v-card  class="rounded-lg" rounded="lg" outlined>
        <v-card-text class="px-10 py-5">
          <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%': 'width: 55%'">
            <v-tabs v-model="tab"  :grow="true" mobile-breakpoint="sm" height="45" class="mt-3">
     
              <v-tab class="ml-0 d-flex justify-space-between">
                <h2 class="font-weight-bold">Approved</h2>
                <p v-show="approved.length">{{approved.length}}</p>
              </v-tab>
              <v-tab class="d-flex justify-space-between">
                <h2 class="font-weight-bold">Pending</h2>
                <p v-show="pending.length">{{pending.length}}</p>
              </v-tab>
              <v-tab class="d-flex justify-space-between">
                <h2 class="font-weight-bold">Drafts</h2>
                <p v-show="drafts.length">{{drafts.length}}</p>
              </v-tab>
              <v-tab class="d-flex justify-space-between">
                <h2 class="font-weight-bold">Rejected</h2>
                <p v-show="rejected.length">{{rejected.length}}</p>
              </v-tab>
            </v-tabs>
          </div>
          <v-divider></v-divider>
          <v-tabs-items v-model="tab">
            <v-tab-item data-testid="approved-blogs-list">
              <div v-if="!loading & hasData" class="mt-5">
                <div class="d-flex flex-row flex-wrap justify-start" >
                  <BlogCard 
                    class="mx-4"
                    v-for="blog in approved" 
                    :key="blog.slug"
                    :blog="blog"
                  />
                </div>
                <div class="col-12 col-md-8 col-lg-8 col-xl-8">
                  <infinite-loading spinner="waveDots" @infinite="fetchMoreBlogs">
                    <div slot="no-results">
                      <v-chip small text-color="primary">You have caught up</v-chip>
                    </div>
                    <div slot="no-more">
                      <v-chip small text-color="primary">You have caught up</v-chip>
                    </div>
                  </infinite-loading>
                </div>
              </div>
              <v-row  v-if="!loading & !hasData" class="mt-5">
                <v-col cols="12" md="10" lg="10" class="mt-5 d-flex flex-column justify-end align-center" style="height: 55vh">
                  <NoData
                      data-testid="empty-blogs-list"
                      :image="emptyPage"
                      :subtitle="dataKind === 'blogs' ? 'Create your first blog': ''"
                      :title="`You have no ${dataKind}`"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <div v-if="!loading & hasData" class="mt-5">
                <div class="d-flex flex-row flex-wrap justify-start" >
                  <BlogCard 
                    v-for="blog in pending" 
                    :key="blog.slug"
                    :blog="blog"
                  />
                </div>
                <div class="col-12 col-md-8 col-lg-8 col-xl-8">
                  <infinite-loading spinner="waveDots" @infinite="fetchMoreBlogs">
                    <div slot="no-results">
                      <v-chip small text-color="primary">You have caught up</v-chip>
                    </div>
                    <div slot="no-more">
                      <v-chip small text-color="primary">You have caught up</v-chip>
                    </div>
                  </infinite-loading>
                </div>
              </div>
              <v-row  v-if="!loading & !hasData" class="mt-5">
                <v-col cols="12" md="10" lg="10" class=" mt-5 d-flex flex-column justify-end align-center" style="height: 55vh">
                  <NoData
                      data-testid="empty-blogs-list"
                      :image="emptyPage"
                      :subtitle="dataKind === 'blogs' ? 'Create your first blog': ''"
                      :title="`You have no ${dataKind}`"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <div v-if="!loading & hasData" class="mt-5">
                <div class="d-flex flex-row flex-wrap justify-start" >
                  <BlogCard 
                    class="mx-4"
                    v-for="blog in drafts" 
                    :key="blog.slug"
                    :blog="blog"
                    :isDraft="true"
                  />
                </div>
                <div class="col-12 col-md-8 col-lg-8 col-xl-8">
                  <infinite-loading spinner="waveDots" @infinite="fetchMoreBlogs">
                    <div slot="no-results">
                      <v-chip small text-color="primary">You have caught up</v-chip>
                    </div>
                    <div slot="no-more">
                      <v-chip small text-color="primary">You have caught up</v-chip>
                    </div>
                  </infinite-loading>
                </div>
              </div>
              <v-row  v-if="!loading & !hasData" class="mt-5">
                <v-col cols="12" md="10" lg="10" class="mt-5 d-flex flex-column justify-end align-center" style="height: 55vh">
                  <NoData
                      data-testid="empty-blogs-list"
                      :image="emptyPage"
                      :subtitle="dataKind === 'blogs' ? 'Create your first blog': ''"
                      :title="`You have no ${dataKind}`"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <div v-if="!loading & hasData" class="mt-5">
                <div class="d-flex flex-row flex-wrap justify-start" >
                  <BlogCard 
                    class="mx-4"
                    v-for="blog in rejected" 
                    :key="blog.slug"
                    :blog="blog"
                  />
                </div>
                <div class="col-12 col-md-8 col-lg-8 col-xl-8">
                  <infinite-loading spinner="waveDots" @infinite="fetchMoreBlogs">
                    <div slot="no-results">
                      <v-chip small text-color="primary">You have caught up</v-chip>
                    </div>
                    <div slot="no-more">
                      <v-chip small text-color="primary">You have caught up</v-chip>
                    </div>
                  </infinite-loading>
                </div>
              </div>
              <v-row  v-if="!loading & !hasData" class="mt-5">
                <v-col cols="12" md="10" lg="10" class="mt-5 d-flex flex-column justify-end align-center" style="height: 55vh">
                  <NoData
                      data-testid="empty-blogs-list"
                      :image="emptyPage"
                      :subtitle="dataKind === 'blogs' ? 'Create your first blog': ''"
                      :title="`You have no ${dataKind}`"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
          <div v-if="loading">
            <v-skeleton-loader
                data-testid="v-skeleton-loader"
                style="height: 35vh"
                v-for="x in 10"
                :key="x"
                :max-width="$vuetify.breakpoint.smAndDown ? '100vw': '50vw'"
                class="my-3"
                type="card,article,list-item-avatar-three-line,actions"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import IsAuthenticatedMixin from "@/mixins/IsAuthenticatedMixin";
import MentorMixin from "@/mixins/MentorMixin";
import { constructDate } from "@/utilz/date";
import BlogCard from "@/components/BlogCard";
import NoData from "@/components/NoData";
import emptyPage from "@/assets/empty_page.svg";
import InfiniteScroll from "@/mixins/InfiniteScroll";

export default {
  mixins: [IsAuthenticatedMixin, MentorMixin, InfiniteScroll],
  components: { BlogCard, NoData },
  metaInfo() {
    return {
      title: "Guiomentor - My Blogs",
      url: window.location.href
    };
  },
  data: () => ({
    emptyPage,
    showLogOutDialog: false,
    drawerOpen: true,
    limit: 5,
    offset: 5,
    loading: false,
    fetchUrl: "",
    tab: null,
    dataKind: '',
  }),
  computed: {
    ...mapGetters({
      user: "auth/GET_USER",
      approved: "blogs/GET_MY_APPROVED_BLOGS",
      drafts: "blogs/GET_MY_DRAFT_BLOGS",
      pending: "blogs/GET_MY_PENDING_BLOGS",
      rejected: "blogs/GET_MY_REJECTED_BLOGS"
    }),
    hasData() {
      if (this.tab === 0) return Boolean(this.approved.length);
      if (this.tab === 1) return Boolean(this.pending.length);
      if (this.tab === 2) return Boolean(this.drafts.length);
      if (this.tab === 3) return Boolean(this.rejected.length);
      else return false
    },
    showCreateButton() {
      return this.user.account_types?.filter((item) => item.name === "MENTOR").length;
    },
  },
  methods: {
    ...mapMutations({
      SET_MY_BLOGS: "blogs/SET_MY_BLOGS"
    }),
    async loadBlogs() {
      try {
        this.loading = true;
        const { data } = await this.axios.get(this.fetchUrl);
        this.SET_MY_BLOGS({tabIndex: this.tab, blogs: data.results})
        this.offset += 5;
        this.next = !!data.next;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if(this.tab !== 1 && error.response?.status !== 404) {
          this.$snackbar.showMessage({
            content: this.$t("errors.somethingWentWrongError"),
            color: "error",
          });
        }
      }
    },
    fetchMoreBlogs($state) {
      this.infiniteHandler($state, "SET_MY_BLOGS")
    },
    blogOwnerName: (owner) => {
      const { first_name, last_name } = owner.profile;
      if (last_name || first_name)
        return `${first_name || ""} ${last_name || ""}`;
      return owner.username;
    },
    blogCreatedAt(blogCreatedAt) {
      const date = new Date(blogCreatedAt);
      return constructDate(date.getDate(), date.getMonth(), date.getFullYear());
    },
  },
  watch: {
    tab(newValue){
      if (newValue === 0) {
        this.fetchUrl = `blogs/user/approved/?limit=${this.limit}`;
        this.dataKind = 'approved blogs'
      }
      if (newValue === 1) {
        this.fetchUrl = `blogs/user/pending/?limit=${this.limit}`
        this.dataKind = 'pending blogs'
      }
      if (newValue === 2) {
        this.fetchUrl = `blogs/user/draft/?limit=${this.limit}`
        this.dataKind = 'drafts'
      }
      if (newValue === 3) {
        this.fetchUrl = `blogs/user/rejected/?limit=${this.limit}`
        this.dataKind = 'rejected blogs'
      }
      this.SET_MY_BLOGS({tabIndex: this.tab, blogs: []})
      this.loadBlogs()
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)::v-deep
.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes)
.v-slide-group__prev {
  display: none !important;
  visibility: hidden !important;
}

.v-tab {
  text-transform: capitalize !important;
  font-weight: 600;
  font-size: 12px;
  line-height: 10px;
  color: #A6A6A6;
}
.user-name{
  font-size:20px;
  line-height: 24px;
  font-weight: 700;
  letter-spacing: 1.4px;
}
.user-facts{
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px; 
  color: #B3B3B3;

}
 .user-facts-bold {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
 }
 .user-meta{
  margin-top: 15px;
 }
 .subscription{
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px; 
  color: #B3B3B3;
 }
 .renew{
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 15px; 
  color: blue;
 }
</style>
